import data from "../StubData/ServerDetails.json";
const fetchData = () => {
  console.log(data);
  return data;
};

const fetchData2 = async () => {
  let data = {};
  // await fetch("./StubData/ServerDetails.json ")
  await fetch("https://randomuser.me/api/")
    .then((res) => res.json())
    .then((json) => (data = json.results))
    .then(() => console.log(data));
  //     .then(()=>console.log("line 10"))
  //     .catch(() => (data = {}));
  return data;
};
export default fetchData;
